export default __webpack_public_path__ + "static/media/Heroz1.ad4970b5.jpg";